<template>
  <v-container fluid class="py-0">
    <v-row class="contacts pb-5 pt-5">
      <v-col cols="12" class="text-center">
        <h1>Contact Us</h1>
        <div class="email-col">
          <i class="fas fa-envelope"></i>
          <a href="mailto:info@tecsvit.com">info@tecsvit.com</a>
        </div>
      </v-col>
    </v-row>
    <!-- <v-row class="contacts pb-10">
      <v-col cols="12" class="text-center">
        <div class="email-col">
          <span>Dmytro Gladush</span>&nbsp;
          <a href="mailto:dmitry.gladush@gmail.com">dmitry.gladush@gmail.com</a>
        </div>
      </v-col>
    </v-row> -->
  </v-container>
</template>

<script>
export default {
  name: "HomeTechStack",

  data: () => ({}),
};
</script>
<style scoped lang="scss">
.contacts {
  background-color: #1a4658;
  h1 {
    margin: 0 8px 0 0;
    padding: 0;
    line-height: 4rem;
    display: inline-block;
  }
  .email-col {
    display: inline-block;
    line-height: 4.75rem;
    margin-left: 8px;
    i {
      font-size: 1.2rem;
    }
    a {
      margin-left: 0.25rem;
      color: white;
      text-decoration: none;
      font-size: 1.2rem;
    }
  }
}
</style>